import React from "react"
import { ReactNode } from 'react';
import { Link as GatsbyLink } from "gatsby"
import {
  Box,
  Flex,
  HStack,
  Link,
  IconButton,
  useDisclosure,
  VisuallyHidden,
  Image,
  Stack,
  Text,
  Button,
  Show
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';

import { useLocation } from "@reach/router"
import LogoImage from "../../images/index/logo.png"
import HamburgerIcon from "../../images/burger.svg"



const NavLink = ({ children, url, external, isActive }: { children: ReactNode, url: string, external?: boolean, isActive: any}) => {
  return (
    <Link
      as={GatsbyLink}
      fontWeight={'bold'}
      fontSize={{base: 'md', md: 'md', lg: 'md', '2xl': 'md'}}
      color={'black'}
      px={2}
      rounded={'md'}
      _hover={{
        textDecoration: 'none',
        bg: 'white',
      }}
      isExternal={external}
      to={url}>
      {children}
    </Link>
  )
};

const Links = [
  {
    link: '会社案内',
    url: '/company/'
  },
  {
    link: '採用情報',
    url: '/recruit/'
  },
  {
    link: 'お問い合わせ',
    url: '/contact/'
  },
];
  

const NavBar: React.FC = (pageContext) => {
  const location = useLocation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  let logo = LogoImage
  let heading = 'コーワ株式会社'

  const isActive = (url) => {
    if (location.pathname == '/' && url == '/') {
      return true
    } else if (location.pathname.match(/^\/company/) && url == '/company') {
      return true
    } else if (location.pathname.match(/^\/products/) && url == '/products') {
      return true
    } else if (location.pathname.match(/^\/recruit/) && url == '/recruit') {
      return true
    } else if (location.pathname.match(/^\/contact/) && url == '/contact') {
      return true
    }
    return false
  }

  return (
    <>
      <Box bg={'white'} shadow={'sm'} w={'full'} position={'fixed'} top={0} zIndex={'1000'}>
        <Flex h={16} mx={'auto'} px={5} alignItems={'center'} justifyContent={'space-between'} w={'100%'}>
          <IconButton
            bg={'white'}
            size={'md'}
            icon={isOpen ? <CloseIcon /> : <Image src={HamburgerIcon}/>}
            aria-label={'Open Menu'}
            display={{ md: 'none' }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems={'center'}>
            <GatsbyLink to={'/'}>
              <Image src={logo} h={16} mr={'32px'} />
            </GatsbyLink>
          <VisuallyHidden as={location.pathname.match(/.+\/.+/) ? 'p' : 'h1'}>{heading}</VisuallyHidden>
          </HStack>
          <Flex alignItems={'center'}>
          <HStack
              as={'nav'}
              spacing={4}
              pt={6}
              display={{ base: 'none', md: 'flex' }}>
              {Links.map((link) => (
                <NavLink key={link.link} url={link.url} isActive={isActive} external={link.external}>{link.link}</NavLink>
              ))}
            </HStack>
          </Flex>
        </Flex>
        {isOpen ? (
          <Box pb={4} display={{ md: 'none' }}>
            <Stack as={'nav'} spacing={4}>
              {Links.map((link) => (
                <NavLink key={link.link} url={link.url} isActive={isActive} external={link.external}>{link.link}</NavLink>
              ))}
            </Stack>
          </Box>
        ) : null}
      </Box>
    </>
  );
}

export default NavBar